import teamsData from "./teams"

let playersHistory = []
for (let i = 0; i<(teamsData.length+1)*20; i++) { // MUST match the number of players created in the players reducer. Teams + free agents * 20
  playersHistory[i] = []
};

export default playersHistory
